<template>
  <span class="filter-group">
    <span v-if="label" class="filter-label">{{ label }}</span>
    <span v-for="opt in options" :key="String(opt.value)" class="filter-pill"
          :class="{ 'is-on': isOn(opt.value) }" @click="pick(opt.value)">
      <i class="pill-dot" :style="opt.color ? { background: opt.color } : null"></i>{{ opt.label }}
    </span>
  </span>
</template>
<script>
export default {
  name: 'FilterPills',
  props: {
    value: { type: [String, Number, Boolean], default: '' },
    options: { type: Array, default: function () { return [] } },
    label: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    isOn (v) {
      return String(v) === String(this.value)
    },
    pick (v) {
      if (this.disabled || this.isOn(v)) {
        return
      }
      this.$emit('input', v)
      this.$emit('on-change', v)
    }
  }
}
</script>
<style scoped lang="less">
@import './vars.less';

.filter-group {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}

.filter-label {
  margin-right: 4px;
  font-size: 12px;
  color: @text-muted;
}

.filter-pill {
  display: inline-flex;
  align-items: center;
  height: 26px;
  padding: 0 10px;
  border: 1px solid transparent;
  border-radius: 13px;
  font-size: 12px;
  color: @text-sub;
  cursor: pointer;
  user-select: none;
  &:hover {
    color: @header-bg;
  }
  &.is-on {
    border-color: rgba(42, 60, 98, .28);
    background: rgba(42, 60, 98, .06);
    font-weight: 600;
    color: @header-bg;
  }
}

.pill-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  margin-right: 6px;
  border-radius: 50%;
  background: #C9D0DC;
}

.filter-pill.is-on .pill-dot {
  background: @header-bg;
}
</style>



// WEBPACK FOOTER //
// FilterPills.vue?227379eb